(function ($) {
  'use strict';

  /**
   * Flip Card Controls
   * - Button to toggle a single content item (In this case, a flip card)
   */

  var $flip_cards = $('.js-flip-card');

  // Track accordion group index for el ids
  var group_index = 0;

  $flip_cards.each(function () {
    group_index++;
    var $this_card = $(this);
    var $this_card_buttons = $this_card.find( '.js-flip-toggle' );
    var $this_card_button_front = $this_card_buttons.filter( '.js-flip-toggle--front' );
    var $this_card_button_back = $this_card_buttons.filter( '.js-flip-toggle--back' );
    var $this_card_front = $this_card.find( '.js-flip-front' );
    var $this_card_back = $this_card.find( '.js-flip-back' );
    var button_id_front = 'js-flip-card-button-front-' + group_index;
    var button_id_back = 'js-flip-card-button-back-' + group_index;
    var region_id = 'js-flip-card-item-' + group_index;

    // Prep Card
    $this_card
      .addClass( 'has-flip-animation' );

    // Prep Buttons
    $this_card_buttons
      .attr( 'aria-controls', region_id )
      .attr( 'aria-expanded', 'false' );
    // Prep Separate Face Button
    $this_card_button_front
      .attr( 'id', button_id_front );
    $this_card_button_back
      .attr( 'id', button_id_back );

    // Prep Card Face - Front
    $this_card_front
      .attr( 'aria-hidden', 'false' );

    // Prep Card Face - Back
    $this_card_back
      .attr( 'id', region_id )
      .attr( 'role', 'region' )
      .attr( 'aria-labelledby', button_id_back )
      .attr( 'aria-hidden', 'true' )
      .prop( 'inert', true );

    // Toggle Press
    $this_card_buttons.on('click', function () {
      var is_expanded = $(this).attr( 'aria-expanded' ) === 'true';

      // Toggle On - Flip to Back
      // - Hides front & displays back
      if ( ! is_expanded ) {
        $this_card
          .addClass( 'is-card-flipped' );
        $this_card_buttons
          .attr( 'aria-expanded', 'true' );
        $this_card_front
          .attr( 'aria-hidden', 'true' )
          .prop( 'inert', true );
        $this_card_back
          .attr( 'aria-hidden', 'false' )
          .prop( 'inert', false );
        $this_card_button_back.focus();

      // Toggle Off - Flip to Front
      // - Hides back & displays front
      } else {
        $this_card
          .removeClass( 'is-card-flipped' );
        $this_card_buttons
          .attr( 'aria-expanded', 'false' );
        $this_card_front
          .attr( 'aria-hidden', 'false' )
          .prop( 'inert', false );
        $this_card_back
          .attr( 'aria-hidden', 'true' )
          .prop( 'inert', true );
        $this_card_button_front.focus();
      }

    });
  });

})(jQuery);
